// POSTHOG_PROVIDER: Tracks SPA pageviews and identifies authenticated users
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { identifyUser, trackPageview } from '@/lib/posthog';

export function PosthogPageviewTracker() {
	const location = useLocation();
	const { user } = useAuth();

	// Track pageviews on route change
	useEffect(() => {
		trackPageview();
	}, [location.pathname]);

	// Identify user when authenticated
	useEffect(() => {
		if (user?.id) {
			identifyUser(user.id, {
				email: user.email,
				name: user.name,
				role: user.role
			});
		}
	}, [user?.id, user?.email, user?.name, user?.role]);

	return null;
}
